"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const standard_1 = require("react-hook-schema/standard");
const __1 = require("..");
const tupleSchemaComponent = (0, standard_1.createTupleSchemaComponent)(() => __1.Field);
exports.default = tupleSchemaComponent;
